import { Injectable, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthenticatedUserService } from '../shared/services/authenticated-user.service';
import { User } from '../shared/models/user';
import { RoleEnum } from '../shared/enums/role.enum';
import { Observable, filter, map, take } from 'rxjs';

@Injectable()
export class AdminPermissionsService {
  private authenticatedUserService = inject(AuthenticatedUserService);

  canActivate(): Observable<boolean> {
    return this.authenticatedUserService.getUserSubject().pipe(
      filter((user): user is User => user !== null),
      take(1),
      map(
        user =>
          user.roleList.includes(RoleEnum.ADMINISTRATOR) || user.roleList.includes(RoleEnum.RESEARCHER)
      )
    );
  }
}

export const AdminGuard: CanActivateFn = () => {
  return inject(AdminPermissionsService).canActivate();
};
